import React from 'react';
import { useTranslation } from 'react-i18next';
import { Block, SmallGrayText } from '@guryou/html-components';
import LinearProgress from '@material-ui/core/LinearProgress';
import { makeStyles } from '@material-ui/core/styles';
import { useOnboardContext } from 'onboard/context';

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  customLinearProgress: {
    backgroundColor: '#9ae3b2',
    height: 6,
    borderRadius: 5,
    '& .MuiLinearProgress-bar': {
      background: '#08822f', // Custom bar color
      borderRadius: 5,
    },
  },
});

const getStepTitle = (step, type, t) => {
  switch (step) {
    case 2:
      return t('ONBOARD.centerComplete');
    case 3:
      return t('ONBOARD.chooseTypeOfService');
    case 4:
      return t(`ONBOARD.${type}General`);
    case 5:
      return t(`ONBOARD.${type}Involvement`);
    case 6:
      return t(`ONBOARD.${type}Location`);
    case 7:
      return t(`ONBOARD.${type}Final`);
    case 8:
      return t(`ONBOARD.${type}Sessions`);
    default:
      return '';
  }
};

const ProgressComponent = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { progress, activeStep, serviceType, maxSteps } = useOnboardContext();
  return (
    <Block lg={10} md={12} xs={12} margin={0} visibility={activeStep <= 1 || activeStep > maxSteps + 1 ? 'hidden' : 'visible'}>
      <SmallGrayText marginBottom={2}>{getStepTitle(activeStep, serviceType, t)}</SmallGrayText>
      <div className={classes.root}>
        <LinearProgress className={classes.customLinearProgress} variant="determinate" value={progress} />
      </div>
    </Block>
  );
};

export default ProgressComponent;
